import CandidatePlacedIcon from "@assets/svg/CandidatePlacedIcon";
import CommissionIcon from "@assets/svg/CommissionIcon";
import EmailSuccess from "@assets/svg/EmailSuccess";
import InvitationAcceptedIcon from "@assets/svg/InvitationAcceptedIcon";
import InviteReceived from "@assets/svg/InviteReceived";
// @ts-ignore
import ProfileImg from "@assets/images/profilepic.png";
// @ts-ignore
import AgencyImg from "@assets/images/agency.jpg";
// @ts-ignore
import GoogleImg from "@assets/images/google.jpg";
import CalenderIcon from "@assets/svg/CalenderIcon";
import AssessmentIcon from "@assets/svg/AssessmentIcon";
import EyeIcon from "@assets/svg/EyeIcon";
import EditIcon from "@assets/svg/EditIcon";
import ProfileIcon from "@assets/svg/ProfileIcon";
import TickThinOutline from "@assets/svg/TickThinOutline";
import JobMatchesIcon from "@assets/svg/JobMatchesIcon";
import { Briefcase, LogOut } from "lucide-react";
import dayjs from "dayjs";

type TrackerType =
  | "placement"
  | "offer"
  | "invitation"
  | "poll"
  | "shortlist"
  | "submit"
  | "view"
  | "applied"
  | "edit"
  | "register";

function getIcon(type: TrackerType) {
  switch (type) {
    case "placement":
      return <Briefcase className={"w-4 h-4"} stroke="gray" />;
    case "offer":
      return <JobMatchesIcon className={"w-4 h-4"} fill={"gray"} />;
    case "invitation":
      return <CalenderIcon className={"w-4 h-4"} fill={"gray"} />;
    case "poll":
      return <CalenderIcon className={"w-4 h-4"} fill={"gray"} />;
    case "shortlist":
      return <AssessmentIcon className={"w-4 h-4"} fill={"gray"} />;
    case "submit":
      return <LogOut height={16} color="#4d4d4d" />;
    // return <CommissionIcon className={"w-4 h-4"} fill={"gray"} />;
    case "view":
      return <EyeIcon className={"w-5 h-5"} fill={"gray"} />;
    case "applied":
      return (
        <TickThinOutline
          className={"w-4 h-4 border rounded-full border-gray-500"}
          fill={"gray"}
        />
      );
    case "edit":
      return <EditIcon className={"w-5 h-5"} fill={"gray"} />;
    case "register":
      return <ProfileIcon className={"w-4 h-4"} fill={"gray"} />;
    default:
      return <CommissionIcon className={"w-4 h-4"} fill={"gray"} />;
  }
}
function getTitle(type: TrackerType) {
  switch (type) {
    case "placement":
      return "Successful placement";
    case "offer":
      return "Offer Received";
    case "invitation":
      return "Interview Invitation";
    case "poll":
      return "Availability Poll";
    case "shortlist":
      return "Shortlisted";
    case "submit":
      return "Application Submitted";
    case "view":
      return "Applcation Viewed";
    case "applied":
      return "Applied";
    case "edit":
      return "Profile Edit";
    case "register":
      return "Registration";
    default:
      return "Default";
  }
}

function getDescImage(type: TrackerType) {
  switch (type) {
    case "offer":
      return <img src={AgencyImg} className="w-7 h-7 rounded-full" />;
    case "invitation":
      return <img src={AgencyImg} className="w-7 h-7 rounded-full" />;
    case "poll":
      return <img src={AgencyImg} className="w-7 h-7 rounded-full" />;
    case "shortlist":
      return <img src={GoogleImg} className="w-7 h-7 rounded-full" />;
    case "submit":
      return <img src={AgencyImg} className="w-7 h-7 rounded-full" />;
    case "view":
      return <img src={AgencyImg} className="w-7 h-7 rounded-full" />;
    default:
      return <img src={ProfileImg} className="w-7 h-7 rounded-full" />;
  }
}

function getDescription(type: TrackerType) {
  switch (type) {
    case "placement":
      return (
        <span className="flex flex-wrap items-center gap-1 text-xs font-medium text-primary">
          <span className="font-bold text-gray-600">You</span>
          <span>have been successfully placed at</span>
          <span className="font-bold text-gray-600">Google Inc</span>
          <span>regarding position title</span>
          <span className="font-bold text-gray-600">ABC Recruitment.</span>
        </span>
      );
    case "offer":
      return (
        <span className="text-xs gap-1 flex flex-wrap text-primary font-medium">
          <span className="font-bold text-gray-600">ABC Recruitment </span>
          sent you an offer from{" "}
          <span className="font-bold text-gray-600">Google </span>
          regarding
          <span className="font-bold text-gray-600">
            React Frontend Developer.
          </span>
        </span>
      );
    case "invitation":
      return (
        <span className="text-xs gap-1 flex flex-wrap text-primary font-medium">
          <span className="font-bold text-gray-600">ABC Recruitment </span>
          has sent you an{" "}
          <span className="font-bold text-gray-600">interview invitation </span>
          for
          <span className="font-bold text-gray-600">
            11am Monday 20th October 2025.
          </span>
        </span>
      );
    case "poll":
      return (
        <span className="text-xs gap-1 flex flex-wrap text-primary font-medium">
          <span className="font-bold text-gray-600">ABC Recruitment </span>
          has sent you an{" "}
          <span className="font-bold text-gray-600">availability poll. </span>
        </span>
      );
    case "shortlist":
      return (
        <span className="text-xs gap-1 flex flex-wrap text-primary font-medium">
          <span className="font-bold text-gray-600">Google Inc </span>
          has shortlisted your application for the position
          <span className="font-bold text-gray-600">
            React Frontend Developer.
          </span>
        </span>
      );
    case "submit":
      return (
        <span className="text-xs gap-1 flex flex-wrap text-primary font-medium">
          <span className="font-bold text-gray-600">ABC Recruitment </span>
          has submitted your application to
          <span className="font-bold text-gray-600">Google Inc </span>
          for the position titled
          <span className="font-bold text-gray-600">
            React Frontend Developer.
          </span>
        </span>
      );
    case "view":
      return (
        <span className="text-xs gap-1 flex flex-wrap text-primary font-medium">
          <span className="font-bold text-gray-600">ABC Recruitment </span>
          has viewed your application for the position
          <span className="font-bold text-gray-600">
            React Frontend Developer.{" "}
          </span>
        </span>
      );
    case "applied":
      return (
        <span className="text-xs gap-1 flex flex-wrap text-primary font-medium">
          <span className="font-bold text-gray-600">You </span>
          applied for the job post
          <span className="font-bold text-gray-600">
            React Frontend Developer{" "}
          </span>
          submitted by
          <span className="font-bold text-gray-600">
            ABC Recruitment Futures Ltd.
          </span>
        </span>
      );
    case "edit":
      return (
        <span className="text-xs gap-1 flex flex-wrap text-primary font-medium">
          <span className="font-bold text-gray-600">You </span>
          successfully updated your skills.
        </span>
      );
    case "register":
      return (
        <span className="text-xs gap-1 flex flex-wrap text-primary font-medium">
          <span className="font-bold text-gray-600">You </span>
          registered successfully on COMTRACKED.
        </span>
      );
    default:
      return (
        <span className="text-xs gap-1 flex flex-wrap text-primary font-medium">
          <span className="font-bold text-gray-600">ABC Recruitment </span>
          sent you an offer from{" "}
          <span className="font-bold text-gray-600">ABC Recruitment </span>
          regarding
          <span className="font-bold text-gray-600">ABC Recruitment.</span>
        </span>
      );
  }
}

type CardProps = {
  type: TrackerType;
};

const Card = ({ type }: CardProps) => {
  return (
    <div className="flex gap-3">
      <div className="flex items-center justify-center w-6 h-6 rounded-full">
        {getIcon(type)}
      </div>
      <div className="flex flex-col gap-1 w-full pt-1">
        <span className="font-semibold text-xs gap-5 flex text-primary">
          {getTitle(type)}
          <span className="font-medium text-light-black">
            {dayjs().format("HH:mm DD/MM/YYYY")}
          </span>
        </span>
        <div className="flex items-center text-xs text-primary bg-[#fafafa] w-full rounded-md p-3 gap-3">
          {getDescImage(type)}
          {getDescription(type)}
        </div>
      </div>
    </div>
  );
};

const CandidateTrackerPageStatic = () => {
  return (
    <div className="flex flex-col flex-1 min-h-0 rounded-md bg-white">
      <span className="font-bold text-primary mx-auto">Activity Tracker</span>

      {/* Tracker List */}
      <div className="flex flex-col min-h-0 my-5 w-[70%] mx-auto gap-6 overflow-y-scroll no-scrollbar">
        <Card type="placement" />
        <Card type="offer" />
        <Card type="invitation" />
        <Card type="poll" />
        <Card type="shortlist" />
        <Card type="submit" />
        <Card type="view" />
        <Card type="applied" />
        <Card type="edit" />
        <Card type="register" />
      </div>
    </div>
  );
};

export default CandidateTrackerPageStatic;